import { observable, computed } from 'mobx';
import { persist, create } from 'mobx-persist';

class Store {
  @persist('object') @observable user = {};
  @persist @observable token = '';
  @persist('list') @observable sections = [];
  @observable logout() {
    this.user = {};
    this.sections = [];
    this.token = '';
  }
}
class Sections {
  @persist('list') @observable value = [];
  @observable clear() {
    this.value = [];
  }
}
class Token {
  @persist @observable value = '';
  @observable clear() {
    this.value = '';
  }
}
class User {
  @persist('object') @observable value = {};
  @observable clear() {
    this.value = {};
  }
}

// const store = (window.store = new Store());
const userStore = new User();
const tokenStore = new Token();
const sectionsStore = new Sections();
const hydrate = create({
  storage: localStorage,
  jsonify: true,
});
hydrate('box-user', userStore).then(() => {});
hydrate('box-token', tokenStore).then(() => {});
hydrate('box-sections', sectionsStore).then(() => {});

export default {
  userStore,
  tokenStore,
  sectionsStore,
};
